// extracted by mini-css-extract-plugin
export default {"tab_link":"TabNavigation_tab_link__FLYnP","active":"TabNavigation_active__IhWBY","tab_navigation":"TabNavigation_tab_navigation__iwms8"};